export default {

    setItem: (key, value) => {
        if (typeof (Storage) !== 'undefined') {
            localStorage.setItem(key, value)
            return true
        }
        return false
    },

    removeItem: (key) => {
        if (typeof (Storage) !== 'undefined') {
            localStorage.removeItem(key)
            return true
        }
        return false
    },

    getItem: (key) => {
        let item = null
        if (typeof (Storage) !== 'undefined') {
            item = localStorage.getItem(key)
        }
        return item
    },

    clear: () => {
        if (typeof (Storage) !== 'undefined') {
            localStorage.clear()
        }
    },
    
    KEYS: {
        TUTO_NEWSLETTERS: 'tuto-newsletters-done',
        NEWSLETTERS_PAGE: 'newsletters-page',
        SHARING_CARD: 'usedSharingCard',
        IS_TUTO_DISCOVERY_DONE: 'is-tuto-discovery-done',
        HIGHLIGHT_STATE: 'highlight-state',
        CONSENT_PRIVACY_VERSION: 'consent-privacy-version',
        COOKIE_LAW_PREFERENCES: 'cookieLawPreferences',
        PARTNER_CODE: 'partnerCode'
    }
    
}
